// Swatch hover preview: shows the hovered color swatch's image as the main image
// without changing the selected variant; restores the selected image on mouseout.
(function () {
function getSectionRoot(el) {
return el.closest('.shopify-section') || document;
}
function getGridForInput(input) {
var root = getSectionRoot(input);
var gallery = root.querySelector('media-gallery');
if (!gallery) return null;
return gallery.querySelector('.media-gallery__grid');
}
function findMediaItem(grid, mediaId) {
if (!grid || !mediaId) return null;
var children = Array.prototype.slice.call(grid.children);
for (var i = 0; i < children.length; i++) {
var li = children[i];
var inner = li.querySelector('[data-media-id]');
var id = inner ? inner.getAttribute('data-media-id') : li.getAttribute('data-media-id');
if (id === mediaId) return li;
}
return null;
}
function showMedia(grid, mediaId) {
var item = findMediaItem(grid, mediaId);
if (item && grid.firstElementChild !== item) {
grid.prepend(item);
}
}
function restoreSelected(input) {
var root = getSectionRoot(input);
var grid = getGridForInput(input);
if (!grid) return;
var checked = root.querySelector('[data-featured-media-id]:checked');
if (checked) {
showMedia(grid, checked.getAttribute('data-featured-media-id'));
}
}
document.addEventListener('mouseover', function (event) {
var input = event.target.closest('[data-featured-media-id]');
if (!input) return;
var mediaId = input.getAttribute('data-featured-media-id');
var grid = getGridForInput(input);
showMedia(grid, mediaId);
});
document.addEventListener('mouseout', function (event) {
var input = event.target.closest('[data-featured-media-id]');
if (!input) return;
if (input.contains(event.relatedTarget)) return;
restoreSelected(input);
});
})();
